import axiosInstance from 'api/axiosInstance';

export const archiveParkingLocation = async (
	parkingLocationId: string,
): Promise<void> => {
	try {
		const API_URL = `/api2.0/parkingLocations/archiveParkingLocation`;
		await axiosInstance.post(
			API_URL,
			{ ParkingLocationId: parkingLocationId },
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);
	} catch (error) {
		console.error('Error archiving parking lot:', error);
		throw error;
	}
};
